import { IncomePeriod } from "enumerations/income-period"

export class ProspectProfileInfo {
    constructor (
        public IncomeAmount: number = null,
        public PreferredMoveIn: Date = null,
        public IncomePeriod: IncomePeriod = null
    ) { }
}
